const manageInquiry = {
  manageInquiry: {
    pageTitle: 'Manage Inquiry',
    description: 'You can manage inquiries and write responses.',
    filters: {
      status: 'Status',
      inquiryType: 'Inquiry Type',
      category: 'Category',
      search: 'Search',
      searchPlaceholder: 'Author, Email...',
      options: {
        all: 'ALL',
        // status
        pending: 'PENDING',
        completed: 'COMPLETED',
        // inquiry type
        useGroundStation: 'Use a ground station',
        shareGroundStation: 'Share a ground station',
        estimateInquiry: 'Estimate Inquiry',
        pressInquiry: 'Make a press inquiry',
        other: 'Other',
        // writer type
        member: 'MEMBER',
        guest: 'GUEST'
      }
    },
    buttons: {
      reset: 'Reset',
      delete: 'Delete ({{count}})',
      deleteConfirm: 'Delete',
      cancel: 'Cancel',
      ok: 'OK'
    },
    totalCount: 'Total {{count}} items',
    deleteModal: {
      title: 'Delete Inquiry',
      body: 'Are you sure you want to delete the {{count}} selected inquiries?\nThis operation cannot be undone.'
    },
    alertModal: {
      titleSuccess: 'Success',
      titleWarning: 'Warning',
      titleError: 'Error'
    },
    alerts: {
      selectItemToDelete: 'Please select items to delete.',
      loadFailed: 'Failed to load inquiries.',
      deleteSuccess: 'The selected inquiries have been deleted.',
      deleteFailed: 'Failed to delete inquiries.'
    }
  }
};

export default manageInquiry;